import {useEffect} from 'react';

export default function useOnKeyPress(targetKey, handler) {
  function downHandler({key}) {
    if (key === targetKey) {
      handler(true);
    }
  }
  const upHandler = ({key}) => {
    if (key === targetKey) {
      handler(false);
    }
  };
  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);
  return [targetKey, handler];
}
